// extracted by mini-css-extract-plugin
export default {"label":"FieldWrapper_label__g3Kmb","wrapper":"FieldWrapper_wrapper__5UUKH"};